import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { VOUCHER_TYPE_PATH } from '../../../../config/paths';
import VoucherTypeDeleteButton from './VoucherTypeDeleteButton';

const VoucherTypeToolbar = ({ voucherTypeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${VOUCHER_TYPE_PATH}/${voucherTypeId}/edit`} />{' '}
      <VoucherTypeDeleteButton voucherTypeId={voucherTypeId} />
    </div>
  </ButtonToolbar>
);

VoucherTypeToolbar.propTypes = {
  voucherTypeId: PropTypes.number.isRequired,
};

export default VoucherTypeToolbar;
